import { useQuery } from '@tanstack/react-query';

import { ASSET_TYPE_PLURALS, ASSET_TYPES } from '@/shared/api/openmetadata';
import { assetKeys } from '@/shared/lib/query/queryKeys';

import { fetchContainerSchema, fetchTableSchema, fetchTopicSchema } from '@/features/asset-detail/api';
import type { ColumnSchema } from '@/features/asset-detail/api/schemaApi';

const SCHEMA_FETCH_HANDLERS: Record<string, (fqn: string) => Promise<ColumnSchema[]>> = {
  [ASSET_TYPES.TABLE]: fetchTableSchema,
  [ASSET_TYPE_PLURALS.TABLE]: fetchTableSchema,
  [ASSET_TYPES.CONTAINER]: fetchContainerSchema,
  [ASSET_TYPE_PLURALS.CONTAINER]: fetchContainerSchema,
  [ASSET_TYPES.TOPIC]: fetchTopicSchema,
  [ASSET_TYPE_PLURALS.TOPIC]: fetchTopicSchema,
} as const;

export const useSchema = (entityType: string, fqn: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: assetKeys.schema(entityType, fqn),
    queryFn: async () => {
      if (!enabled) {
        return null;
      }

      const fetchHandler = SCHEMA_FETCH_HANDLERS[entityType];

      if (!fetchHandler) {
        console.warn(`Schema not supported for entity type: ${entityType}`);
        return null;
      }

      return fetchHandler(fqn);
    },
    staleTime: 5 * 60 * 1000,
    enabled: enabled && !!entityType && !!fqn,
    retry: 1,
  });
};
